/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {readUserSettings} from '../api'

export const useMutationReadUserSettings = createReactQueryMutationHook('readUserSettings', readUserSettings)
